import { getParamByISO } from 'iso-country-currency';

import { COUNTRY_CODE_EXCEPTION_MAP, GLOBAL_COUNTRY_CODE } from 'watchtower-ui/types/country';
import type { CountryISO } from 'watchtower-ui/types/country';

export const countryISOToName = (countryISO: CountryISO) => {
  if (countryISO?.toUpperCase() === GLOBAL_COUNTRY_CODE) {
    return 'Global';
  }
  try {
    return getParamByISO(countryISO, 'countryName');
  } catch {
    return countryISO;
  }
};

export const countryISOToCurrencySymbol = (countryISO: CountryISO) => {
  // Global is a pseudo-country with no ISO currency; the global backend reports everything in USD.
  // Without this the lookup throws and the catch returns the code itself, labelling fields "(GLOBAL)".
  if (countryISO?.toUpperCase() === GLOBAL_COUNTRY_CODE) {
    return 'USD';
  }
  try {
    return getParamByISO(countryISO, 'symbol');
  } catch {
    return countryISO;
  }
};

export const normalizeCountryCode = (code: string): CountryISO => {
  // Normalizing country codes to uppercase
  let countryCode = code.toUpperCase();

  // Adding exception for country codes that differ
  if (COUNTRY_CODE_EXCEPTION_MAP[countryCode]) {
    countryCode = COUNTRY_CODE_EXCEPTION_MAP[countryCode]!;
  }

  return countryCode;
};

export const denormalizeCountryCode = (code: CountryISO): string => {
  // Reverse mapping for denormalization if needed
  const entry = Object.entries(COUNTRY_CODE_EXCEPTION_MAP).find(([, value]) => value === code);
  return entry ? entry[0] : code;
};
